import React, { useState, useEffect } from "react";
import {
  Modal,
  Button,
  Table,
  Form,
  Card,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import { useAuth } from "../../Utils/Auth";
import TransactionSercvice from "../../Services/TransactionSercvice";
const RenewPermission = ({
  SubAdmins = [],
  ID,
  show,
  handleClose,
  onSubmit,
  toggle,
  setToggle,
  isBackButtonShow = true
}) => {
  // const [toggle, setToggle] = useState(true); // need to do false while close
  const [subAdmin, setSubAdmin] = useState([]);
  const [checkboxStates, setCheckboxStates] = useState([]);
  const [checkboxIsView, setCheckboxIsView] = useState([]);
  const [checkboxIsDeposit, setCheckboxIsDeposit] = useState([]);
  const [checkboxIsWithdraw, setCheckboxIsWithdraw] = useState([]);
  const [checkboxIsEdit, setCheckboxIsEdit] = useState([]);
  const [checkboxIsDelete, setCheckboxIsDelete] = useState([]);
  const [checkboxIsRenew, setCheckboxIsRenew] = useState([]);
  const [subAdminlist, setSubAdminlist] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const auth = useAuth();

useEffect(() => {
  if (!auth.user) return;

  TransactionSercvice.subAdminList(auth.user, searchQuery)
    .then((res) => {
      setSubAdmin(res.data.data);
      setSubAdminlist(res.data.data.map((data) => data.userName));
    })
    .catch((err) => {
      console.error("Error fetching sub-admin list:", err);
    });
}, [auth.user, searchQuery]);

  const setData = () => {
    setCheckboxIsView(arrView);
    setCheckboxIsDeposit(arrDeposit);
    setCheckboxIsWithdraw(arrWithdraw);
    setCheckboxIsEdit(arrEdit);
    setCheckboxIsDelete(arrDelete);
    setCheckboxIsRenew(arrRenew);
    setCheckboxStates(newArray);
  };

  const handleToggle = () => {
    setToggle(!toggle);
    setSearchQuery("")
    setData();
  };

  //   const handleClose = () => {
  //     // setShow(false);
  //     setToggle(true);
  //     setData();
  //   };

  const mergedArray = [
    ...subAdmin.map((item) => ({
      subAdminId: item.userName,
      isDeposit: false,
      isWithdraw: false,
      isEdit: false,
      isRenew: false,
      isDelete: false,
      _id: item._id,
    })),
    ...SubAdmins,
  ];

  const uniqueMergedArray = [
    ...new Map(mergedArray.map((item) => [item.subAdminId, item])).values(),
  ];
  let arrView = []
  let arrDeposit = [];
  let arrWithdraw = [];
  let arrEdit = [];
  let arrRenew = [];
  let arrDelete = [];
  const newArray = new Array(uniqueMergedArray.length).fill(false);

  SubAdmins.forEach((subAdmin) => {
    const index = uniqueMergedArray.findIndex(
      (item) => item.subAdminId === subAdmin.subAdminId
    );
    if (index !== -1) {
      newArray[index] = subAdmin.subAdminId;
    }
  });

  for (let i = 0; i < uniqueMergedArray.length; i++) {
    arrView.push(uniqueMergedArray[i].isView);
    arrDeposit.push(uniqueMergedArray[i].isDeposit);
    arrWithdraw.push(uniqueMergedArray[i].isWithdraw);
    arrEdit.push(uniqueMergedArray[i].isEdit);
    arrRenew.push(uniqueMergedArray[i].isRenew);
    arrDelete.push(uniqueMergedArray[i].isDelete);
  }

  const updateAllChildren = (array, index, value) => {
    const newArray = [...array];
    newArray[index] = value;
    return newArray;
  };

  // Checkbox handlers
  const handleCheckboxChange = (e, index) => {
    const newCheckboxStates = [...checkboxStates];
    newCheckboxStates[index] = e.target.checked;
    setCheckboxStates(newCheckboxStates);
    if (e.target.checked) {
      setCheckboxIsView((prev) => updateAllChildren(prev, index, true));
      setCheckboxIsDeposit((prev) => updateAllChildren(prev, index, true));
      setCheckboxIsWithdraw((prev) => updateAllChildren(prev, index, true));
      setCheckboxIsEdit((prev) => updateAllChildren(prev, index, true));
      setCheckboxIsDelete((prev) => updateAllChildren(prev, index, true));
      setCheckboxIsRenew((prev) => updateAllChildren(prev, index, true));
    } else {
      setCheckboxIsView((prev) => updateAllChildren(prev, index, false));
      setCheckboxIsDeposit((prev) => updateAllChildren(prev, index, false));
      setCheckboxIsWithdraw((prev) => updateAllChildren(prev, index, false));
      setCheckboxIsEdit((prev) => updateAllChildren(prev, index, false));
      setCheckboxIsDelete((prev) => updateAllChildren(prev, index, false));
      setCheckboxIsRenew((prev) => updateAllChildren(prev, index, false));
    }
  };

  const updateParrent = (e, index) => {
    const newCheckboxStates = [...checkboxStates];
    newCheckboxStates[index] = e.target.checked;
    setCheckboxStates(newCheckboxStates);
  };
  const handleCheckboxIsViewChange = (e, index) => {
    const newCheckboxIsView = [...checkboxIsView];
    newCheckboxIsView[index] = e.target.checked;
    setCheckboxIsView(newCheckboxIsView);
    if (e.target.checked) {
      updateParrent(e, index);
    }
    else {
      updateParrent(e, index);
      setCheckboxIsView((prev) => updateAllChildren(prev, index, false));
      setCheckboxIsDeposit((prev) => updateAllChildren(prev, index, false));
      setCheckboxIsWithdraw((prev) => updateAllChildren(prev, index, false));
      setCheckboxIsEdit((prev) => updateAllChildren(prev, index, false));
      setCheckboxIsDelete((prev) => updateAllChildren(prev, index, false));
      setCheckboxIsRenew((prev) => updateAllChildren(prev, index, false));
    }
  };

  const handleCheckboxIsDepositChange = (e, index) => {
    const newCheckboxIsDeposit = [...checkboxIsDeposit];
    newCheckboxIsDeposit[index] = !newCheckboxIsDeposit[index];
    setCheckboxIsDeposit(newCheckboxIsDeposit);
    if (e.target.checked) {
      handleCheckboxIsViewChange(e, index);
      updateParrent(e, index);
    }
  };

  const handleCheckboxIsWithdrawChange = (e, index) => {
    const newCheckboxIsWithdraw = [...checkboxIsWithdraw];
    newCheckboxIsWithdraw[index] = !newCheckboxIsWithdraw[index];
    setCheckboxIsWithdraw(newCheckboxIsWithdraw);
    if (e.target.checked) {
      handleCheckboxIsViewChange(e, index);
      updateParrent(e, index);
    }
  };

  const handleCheckboxIsEditChange = (e, index) => {
    const newCheckboxIsEdit = [...checkboxIsEdit];
    newCheckboxIsEdit[index] = !newCheckboxIsEdit[index];
    setCheckboxIsEdit(newCheckboxIsEdit);
    if (e.target.checked) {
      handleCheckboxIsViewChange(e, index);
      updateParrent(e, index);
    }
  };

  const handleCheckboxIsDeleteChange = (e, index) => {
    const newCheckboxIsDelete = [...checkboxIsDelete];
    newCheckboxIsDelete[index] = !newCheckboxIsDelete[index];
    setCheckboxIsDelete(newCheckboxIsDelete);
    if (e.target.checked) {
      handleCheckboxIsViewChange(e, index);
      updateParrent(e, index);
    }
  };

  const handleCheckboxIsRenewChange = (e, index) => {
    const newCheckboxIsRenew = [...checkboxIsRenew];
    newCheckboxIsRenew[index] = !newCheckboxIsRenew[index];
    setCheckboxIsRenew(newCheckboxIsRenew);
    if (e.target.checked) {
      handleCheckboxIsViewChange(e, index);
      updateParrent(e, index);
    }
  };

  const handleSave = () => {
    let arr = [];
    const handledata = () => {
      let data = {};
      for (let i = 0; i < subAdminlist.length; i++) {
        if (
          checkboxStates[i] === true ||
          (typeof checkboxStates[i] === "string" &&
            checkboxStates[i].trim() !== "")
        ) {
          data = {
            subAdminId: subAdminlist[i],
            isView: checkboxIsView[i],
            isDeposit: checkboxIsDeposit[i],
            isWithdraw: checkboxIsWithdraw[i],
            isEdit: checkboxIsEdit[i],
            isDelete: checkboxIsDelete[i],
            isRenew: checkboxIsRenew[i],
          };
          arr.push(data);
        }
      }
      return arr;
    };
    handledata();

    const data = {
      subAdmins: arr,
    };

    const exsistingAdminIds = new Set(
      data?.subAdmins.map((item) => item.subAdminId)
    );
    SubAdmins.forEach((item) => {
      if (!exsistingAdminIds.has(item.subAdminId)) {
        data.subAdmins.push({
          subAdminId: item.subAdminId,
          isView: false,
          isDeposit: false,
          isWithdraw: false,
          isEdit: false,
          isDelete: false,
          isRenew: false,
        });
      }
    });
    onSubmit(data, ID);
  };

  // const handleSearch = (e) => {
  //   const query = e.target.value.toLowerCase();
  //   setSearchQuery(query);
  // };


  const handleSearch = (e) => {
  setSearchInput(e.target.value.toLowerCase());
};

// Debounce logic for storing into state after delay
useEffect(() => {
  const handler = setTimeout(() => {
    setSearchQuery(searchInput);
  }, 500); // 500ms delay

  return () => clearTimeout(handler);
}, [searchInput]);

  return (
    <>
      {/* <Button variant="primary" onClick={handleShow}>
        Renew Permissions
      </Button> */}

      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header
          closeButton
          style={{ backgroundColor: "#3b6e91", color: "#fff" }}
        >
          <Modal.Title>
            {toggle ? "Previous Permissions" : "Update Permissions"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
          {toggle ? (
            <>
              {SubAdmins && SubAdmins.length > 0 ? (
                <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th>SubAdmin</th>
                      <th>View</th>
                      <th>Deposit</th>
                      <th>Withdraw</th>
                      <th>Edit</th>
                      <th>Delete</th>
                      <th>Renew</th>
                    </tr>
                  </thead>
                  <tbody>
                    {SubAdmins.map((subAdmin) => (
                      <tr key={subAdmin._id}>
                        <td>{subAdmin.subAdminId}</td>
                        {/* <td>{subAdmin?.isView ? "Yes" : "No"}</td> */}
                        {/* temporary */}
                        <td>{"Yes"}</td>
                        <td>{subAdmin?.isDeposit ? "Yes" : "No"}</td>
                        <td>{subAdmin?.isWithdraw ? "Yes" : "No"}</td>
                        <td>{subAdmin?.isEdit ? "Yes" : "No"}</td>
                        <td>{subAdmin?.isDelete ? "Yes" : "No"}</td>
                        <td>{subAdmin?.isRenew ? "Yes" : "No"}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <p className="text-center">No permissions found</p>
              )}
            </>
          ) : (
            <Container fluid>

              {/* <Row className="mb-4">
                <Col md={12}>
                  <Card border="light" className="shadow-sm">
                    <Card.Body>
                      <div className="d-flex align-items-center">
                        <Form.Control
                          type="text"
                          placeholder="Search Sub Admins..."
                          // className="border-end-0 rounded-end-0"
                          style={{ height: "45px" }}
                        // Add your search handler here
                        onChange={handleSearch}
                        />
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row> */}
              <Row>
                {subAdmin?.map((admin, index) => {
                  if (index === 0) return null;
                  return (
                    <Col md={12} key={index} className="mb-3">
                      <Card border="primary">
                        <Card.Body>
                          <div className="d-flex align-items-center mb-3">
                            <Form.Check
                              type="checkbox"
                              id={`checkbox${index}`}
                              label={admin.userName}
                              checked={checkboxStates[index]}
                              onChange={(e) => handleCheckboxChange(e, index)}
                              value={admin.userName}
                              className="fw-bold me-3"
                              style={{ color: "#3b6e91" }}
                            />
                          </div>
                          <hr />
                          <div className="d-flex flex-wrap gap-4">
                            {[
                              {
                                label: "View",
                                state: checkboxIsView,
                                handler: handleCheckboxIsViewChange,
                              },

                              {
                                label: "Deposit",
                                state: checkboxIsDeposit,
                                handler: handleCheckboxIsDepositChange,
                              },
                              {
                                label: "Withdraw",
                                state: checkboxIsWithdraw,
                                handler: handleCheckboxIsWithdrawChange,
                              },
                              {
                                label: "Edit",
                                state: checkboxIsEdit,
                                handler: handleCheckboxIsEditChange,
                              },
                              {
                                label: "Delete",
                                state: checkboxIsDelete,
                                handler: handleCheckboxIsDeleteChange,
                              },
                              {
                                label: "Renew",
                                state: checkboxIsRenew,
                                handler: handleCheckboxIsRenewChange,
                              },
                            ].map(({ label, state, handler }, idx) => (
                              <Form.Check
                                key={idx}
                                type="checkbox"
                                id={`${label}${index}`}
                                label={label}
                                checked={state[index]}
                                onChange={(e) => handler(e, index)}
                                className="fw-bold"
                                style={{ color: "#708090" }}
                              />
                            ))}
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  );
                })}
              </Row>
            </Container>
          )}
        </Modal.Body>

        <Modal.Footer>
          {toggle ? (
            <>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
              <Button
                onClick={handleToggle}
                style={{ backgroundColor: "#4682b4" }}
              >
                Renew
              </Button>
            </>
          ) : (
            <>
              {isBackButtonShow &&
                <Button variant="secondary" onClick={handleToggle}>
                  Back
                </Button>
              }
              <Button
                onClick={handleSave}
                className="app-button-color"
                style={{ backgroundColor: "#4682b4" }}
              >
                Save
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>      
    </>
  );
};

export default React.memo(RenewPermission);
